export const SET_GENERAL_INFO = "SET_GENERAL_INFO"
export const SET_BUSINESS_DETAILS = "SET_BUSINESS_DETAILS"
export const SET_VALUATION_INFO = "SET_VALUATION_INFO"
export const SET_DISCLOSURE = "SET_DISCLOSURE"